import { render, staticRenderFns } from "./RestaurantHeader.vue?vue&type=template&id=7c71f31c&scoped=true&"
import script from "./RestaurantHeader.vue?vue&type=script&lang=js&"
export * from "./RestaurantHeader.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantHeader.vue?vue&type=style&index=0&id=7c71f31c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c71f31c",
  null
  
)

export default component.exports